import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, ElementRef,
  EventEmitter, Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges, ViewChild
} from "@angular/core";
import * as _ from "lodash";
import {
  CdkDrag,
  CdkDragDrop,
  CdkDragEnter,
  CdkDropList,
  moveItemInArray,
  transferArrayItem
} from "@angular/cdk/drag-drop";
import * as moment from 'moment';
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {PlanningPanelModel} from "../../../../planning/models/planning-panel.model";
import {PlanningViewSettingsModel} from "../../../../planning/models/planning-view-settings.model";
import {VisitPlanRouteModel, VisitScheduleActivityDetailsModel} from "../../../models/visit-plan-route.model";
import {isVisitPlanRouteDispatched} from "../../../models/visit-plan-route.functions";
import {Subscription} from "rxjs";
import {VisitPlanModel} from "../../../models/visit-plan.model";
import {VisitPlanCellModel} from "../../../models/visit-plan-cell.model";
import {VisitPlanRouteCallServiceTimeModel} from "../../../models/visit-plan-route-call-service-time.model";
import {VisitPlanHttpService} from "../../services/visit-plan-http.service";
import {VisitPlanAccountFacadeService} from "../../services/visit-plan-account-facade.service";

require('./visit-plan-route-tasks-panel-list.scss');
@Component({
  standalone: false,
  selector: 'app-visit-plan-route-tasks-panel-list',
  templateUrl: './visit-plan-route-tasks-panel-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class VisitPlanRouteTasksPanelListComponent implements OnInit, OnChanges, OnDestroy {

  @Input() index: any;
  @Input() panel: PlanningPanelModel;
  @Input() route: VisitPlanRouteModel;
  @Input() jobs: any[];
  @Input() panels: PlanningPanelModel[];
  @Input() routes: any;
  @Input() resources: any;
  @Input() settings: PlanningViewSettingsModel;
  @Input() visibleIds: string[];
  @Input() selectedJobIds: string[];
  @Input() selectedJobs: any[];
  @Input() highlightedActivity?: any;
  @Input() isLoading: boolean;
  @Input() itemElementSize: string;
  @Input() isDisplayRetrips: boolean;
  @Input() isValidateRouteVehicles: boolean;
  @Input() isAllowDraggingIntoDispatchedRoute: boolean;
  @Input() queryText: string;
  @Input() agentColorMap: { [key: string]: string };
  @Input() hasNotSyncedChanges: boolean;
  @Input() isDayDispatched: boolean;
  @Input() visitPlan: VisitPlanModel;
  @Input() programTypeAliasMap: { [key: string]: string };
  @Output() onSelect = new EventEmitter();
  @Output() onSelectJobs = new EventEmitter<string[]>();
  @Output() onViewJob = new EventEmitter<boolean>();
  @Output() onVisibleRoutesChange = new EventEmitter<string[]>();
  @Output() onLockRouteChange = new EventEmitter<{ id: string, locked: boolean }>();
  @Output() onMoveJobs = new EventEmitter();
  @Output() onAddStopsToRoute = new EventEmitter();
  @Output() onDispatch = new EventEmitter<string>();
  @Output() onReoptimize = new EventEmitter<string>();
  @Output() onPrint = new EventEmitter<string>();
  @Output() onPrintLoadingSheet = new EventEmitter<string>();
  @Output() onDelete = new EventEmitter<string>();
  @Output() onChangeRouteResource = new EventEmitter<{ routeId: string, event: any }>();
  @Output() onToggleObligateTimeWindow = new EventEmitter<{ jobIds: string[], obligateTimeWindow: boolean }>();
  @Output() onEditResourceAllocation = new EventEmitter<{ route: any, event: any }>();
  @Output() onEditCallServiceTime = new EventEmitter<{ callId: string, slot: VisitPlanCellModel, isDayDispatched: boolean, event: MouseEvent }>();

  public connectedPanelIds: string[];
  private allowedDropIndexes: Set<number>;
  public selectedKeys: Object = {};
  public visibleKeys: Object;
  public tripTotalsMap: Object;
  public routeColor: string;
  public isSmallScreen: boolean;
  public isRunning: boolean = false;
  public isRouteEditingBlocked: boolean = false;
  public activityDetailsMap: any;
  public callServiceTimeMap: { [callId: string]: VisitPlanRouteCallServiceTimeModel } = {};
  private callSlotMap: { [callId: string]: VisitPlanCellModel } = {};
  private updateCellTrackerResultSubscription: Subscription;

  constructor(
    @Inject(ElementRef) private elementRef,
    @Inject('$timeout') private $timeout,
    @Inject('confirmDialogService') private confirmDialogService,
    @Inject('schedulingProjectAlertsService') private schedulingProjectAlertsService,
    @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
    @Inject(VisitPlanHttpService) private visitPlanHttpService: VisitPlanHttpService,
    @Inject(VisitPlanAccountFacadeService) private visitPlanAccountFacadeService: VisitPlanAccountFacadeService) {
  }

  ngOnInit() {
    this.sortPredicate = this.sortPredicate.bind(this);
    this.isSmallScreen = window.innerWidth < 1366;
    // this.initLockedActivities();
    this.selectedJobIds = [];
    this.onSelectJobs.emit(this.selectedJobs);

    this.updateCellTrackerResultSubscription = this.visitPlanAccountFacadeService.onUpdateCellTrackerResult()
      .subscribe((isSuccess) => {
        if (isSuccess) {
          this._loadCallSlots();
        }
      });
  }

  ngOnDestroy() {
    this.updateCellTrackerResultSubscription?.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedJobIds) {
      this.selectedKeys = {};

      this.selectedJobIds?.forEach((id) => {
        const activities = this.route.activities.filter((a) => {
          return a.jobIds ? _.includes(a.jobIds, id) : (a.jobId === id);
        })

        activities.forEach((a) => {
          this.selectedKeys[a.id] = true;
        })
      })

    }
    if (changes.route) {
      const currentRoute = changes.route.currentValue,
        previousRoute = changes.route.previousValue;

      if (currentRoute?.id !== previousRoute?.id) {
        const el = this.elementRef.nativeElement.querySelector('.dndList');
        if (el) {
          (el as HTMLElement).scrollTo({top: 0, behavior: 'smooth'})
        }
      }

      this._setActivityDetailsMap();
      this._setIsRouteProcessRunning();
      this._loadCallSlots();
    } else if (changes.visitPlan && changes.visitPlan.previousValue?.id !== this.visitPlan?.id) {
      this._loadCallSlots();
    }

    if (changes.panels || changes.routes || changes.resources) {
      const filteredPanels = _.filter(this.panels, (p) => {
        return p.selectedRouteId ? (this.route.id !== p.selectedRouteId) : true;
      })
      this.connectedPanelIds = _.concat(_.map(filteredPanels, 'id'), _.map(this.routes, 'id'), _.map(this.resources, 'id'));
    }
    if (changes.visibleIds) {
      this.visibleKeys = {};
      _.forEach(this.visibleIds, (id) => {
        this.visibleKeys[id] = true;
      });
    }

    if (changes.queryText) {
      setTimeout(() => this.scrollToFirstHighlight(), 0);
    }

    this._setIsRouteEditingBlocked();
  }

  get blockedActionTooltipKey(): string {
    return this.isDayDispatched ? 'VISIT_SCHEDULE_TOOLTIPS.ACTION_BLOCKED_CALL_DISPATCHED' : '';
  }

  private _setIsRouteEditingBlocked() {
    this.isRouteEditingBlocked = !!this.isLoading ||
      this.route?.locked ||
      this.isRunning ||
      isVisitPlanRouteDispatched(this.route) ||
      this.hasNotSyncedChanges ||
      this.isDayDispatched;
  }

  scrollToFirstHighlight(): void {
    const el = this.elementRef.nativeElement.querySelector('.highlight');
    // const el = document.querySelector('.highlight');
    if (el) {
      (el as HTMLElement).scrollIntoView({behavior: 'smooth', block: 'center'});
    }
  }

  // isActivityLocked(activity) {
  //   if (activity?.jobId) {
  //     return !!this.jobsMap[activity.jobId].lockedRouteId;
  //   } else if (activity?.jobIds?.length) {
  //     for (let id of activity.jobIds) {
  //       if (!!this.jobsMap[id]?.lockedRouteId) {
  //         return true;
  //       }
  //     }
  //     return false;
  //   }
  // }

  onSelectedChange(item: any, isSelected: boolean) {
    let selectedIds;
    let jobIds = item.jobIds ? item.jobIds : [item.jobType ? item.id : item.jobId];

    if (isSelected) {
      selectedIds = _.uniq([...this.selectedJobIds].concat(jobIds));
    } else {
      selectedIds = this.selectedJobIds.filter(id => !jobIds.includes(id));
    }

    this.onSelectJobs.emit(_.compact(selectedIds));
  }

  onToggleVisibleRoute(id, isVisible: boolean) {
    this.visibleKeys[id] = isVisible;
    const visibleIds = _.map(this.visibleKeys, (value, key) => {
      if (value) return key;
    });

    this.onVisibleRoutesChange.emit(_.compact(visibleIds));
  }

  isMultipleActivitiesDragged(jobIds) {
    return this.selectedJobIds?.length > 1 && !!_.intersection(this.selectedJobIds, jobIds).length;
  }

  sortPredicate(index: number, item: CdkDrag<any>, drop: CdkDropList) {

    const startIndex = _.findIndex(drop.data, (a: any) => {
      return a.type === 'START';
    })
    const endIndex = _.findIndex(drop.data, (a: any) => {
      return a.type === 'END';
    })

    const isSameRoute = item.data.routeId === this.route.id;

    if (
      ((startIndex > -1) && (startIndex >= index)) ||
      ((endIndex > -1) && (isSameRoute ? (endIndex <= index) : (endIndex < index)))
    ) {
      return false;
    }

    // if (((startIndex > -1) && (startIndex >= index)) || ((endIndex > -1) && endIndex < index)) {
    //   return false;
    // }

    return true;

    // // Add Job To Route
    // if (item.data.jobType) {
    //   return true;
    // }
    // // Add Activity To Route
    // else {
    //   const itemType = item.data.type;
    //   const stopType = item.data.stopType;
    //
    //
    //   const connectedIndexes = [];
    //
    //   drop.data.forEach((a, i) => {
    //     const jobIds = a.jobIds || [a.jobId];
    //     const itemJobIds = item.data.jobIds || [item.data.jobId];
    //     if ((item.data.id !== a.id) && !!_.intersection(jobIds, itemJobIds).length) {
    //       connectedIndexes.push(i)
    //     }
    //   })
    //
    //   if (connectedIndexes.length) {
    //
    //     let canMove = true;
    //
    //     if (stopType === 'Pickup') {
    //       connectedIndexes.forEach((i) => {
    //         if (i <= index) {
    //           canMove = false;
    //         }
    //       })
    //       return canMove;
    //     }
    //
    //     if (stopType === 'Dropoff') {
    //       connectedIndexes.forEach((i) => {
    //         if (i >= index) {
    //           canMove = false;
    //         }
    //       })
    //       return canMove;
    //     }
    //
    //   } else {
    //     return true;
    //   }
    // }

  }

  enter(event: CdkDragEnter) {

  }

  drop(event: CdkDragDrop<string[]>) {
    if (!event.isPointerOverContainer) {
      return false;
    }

    if ((event.previousContainer === event.container) && (event.currentIndex === event.previousIndex)) {
      return;
    }

    if (this.isDayDispatched) {
      this.schedulingProjectAlertsService.moveJobsDayDispatchedError();
      return false;
    }

    const jobIds = event.item.data.jobIds || [event.item.data.jobType ? event.item.data.id : event.item.data.jobId];
    const itemJobs = _.filter(this.jobs, (j) => {
      return _.includes(jobIds, j.id);
    })
    const itemSkills = _.flatMap(itemJobs, (j) => {
      return j.skills || [];
    })

    const currentRouteSkills = this.route.resource?.allocationSkills;
    if (currentRouteSkills && !!_.difference(itemSkills, currentRouteSkills).length) {
      this.schedulingProjectAlertsService.noMatchingSkillsInfo();
      return false
    }

    const movedTaskNotBefore = moment(event.item.data.notBefore).startOf('day').valueOf();
    const resourceStartTime = this.route.resource?.startTime ?
      moment(this.route.resource?.startTime).startOf('day').valueOf()
      : undefined;
    const resourceEndTime = this.route.resource?.endTime ?
      moment(this.route.resource?.endTime).endOf('day').valueOf()
      : undefined;

    if (
      !moment(movedTaskNotBefore).isBetween(
        moment(resourceStartTime),
        moment(resourceEndTime),
        undefined,
        '[]'
      )
    ) {
      this.schedulingProjectAlertsService.moveBetweenDaysInfo();
      return false;
    }

    // ---- Snapshot BEFORE mutation (capture array references + copies) ----
    const prevListRef = event.previousContainer.data as any[];
    const currListRef = event.container.data as any[];

    const prevListSnapshot = [...prevListRef];
    const currListSnapshot = [...currListRef];


    if (event.previousContainer === event.container) {
      moveItemInArray(this.route.activities, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }

    const fromRouteId = _.get(event.previousContainer, 'data[0].routeId');
    const toRouteId = this.route.id;

    const payload = {
      jobIds: jobIds,
      fromRouteId: fromRouteId,
      toRouteId: toRouteId,
      fromOrderedIds: this._getStopsOrderIds(event.previousContainer.data),
      toOrderedIds: (fromRouteId !== toRouteId) ? this._getStopsOrderIds(event.container.data) : undefined
    }

    const rollbackData = {
      fromRouteId,
      toRouteId,
      prevListSnapshot,
      currListSnapshot
    }

    this.onMoveJobs.emit({payload: payload, rollbackData: rollbackData});

    // const payload = {
    //   jobIds: event.item.data.jobIds || [event.item.data.jobId],
    //   fromRouteId: fromRouteId,
    //   toRouteId: toRouteId,
    //   fromOrderedIds: this._getStopsOrderIds(event.previousContainer.data),
    //   toOrderedIds: (fromRouteId !== toRouteId) ? this._getStopsOrderIds(event.container.data) : undefined
    // }
    // this.onMoveJobs.emit(payload);
  }

  onClose(): void {
    this.selectedJobIds = [];
    this.onSelectJobs.emit(this.selectedJobIds);
    this.onSelect.emit();
  }

  onEditServiceTime(callId: string, event: MouseEvent) {
    const slot = this.callSlotMap[callId];
    if (!slot) return;

    this.onEditCallServiceTime.emit({callId, slot, isDayDispatched: this.isDayDispatched, event});
  }

  private _loadCallSlots() {
    const callIds = _.compact(_.uniq(_.map(this.route?.activityDetails, 'callId')));
    this.callSlotMap = {};
    this.callServiceTimeMap = {};

    if (!this.visitPlan?.id || !callIds.length) return;

    this.visitPlanHttpService.getVisitSlots(this.visitPlan.id, {callIds, expand: true, size: callIds.length})
      .subscribe((page) => {
        // New map references so the list items' ngOnChanges picks them up
        const callSlotMap: { [callId: string]: VisitPlanCellModel } = {};
        const callServiceTimeMap: { [callId: string]: VisitPlanRouteCallServiceTimeModel } = {};

        page?.content?.forEach((slot) => {
          const cell = slot.tracker?.entity || slot;

          cell.calls?.forEach((call) => {
            if (!_.includes(callIds, call.id)) return;

            const serviceTime = call.destination?.serviceTime;
            const programType = call.programType?.adjusted?.value ?? call.programType?.initial?.value;
            callSlotMap[call.id] = slot;
            callServiceTimeMap[call.id] = {
              adjustedServiceTime: serviceTime?.hasPendingChanges ? serviceTime.adjusted?.value?.generatedTotalTime : undefined,
              isEditable: this.programTypeAliasMap?.[programType] === 'M'
            };
          })
        })

        this.callSlotMap = callSlotMap;
        this.callServiceTimeMap = callServiceTimeMap;
        this.cdr.markForCheck();
      });
  }

  private _setActivityDetailsMap() {
    this.activityDetailsMap = {};
    const bundleTasks = this.route?.activities?.filter((a) => {
      return a.type === 'GROUP';
    })
    this.route?.activityDetails?.forEach((ad: VisitScheduleActivityDetailsModel) => {
      this.activityDetailsMap[ad.activityId] = ad;

      // Bundle Support Mapping
      bundleTasks.forEach((t) => {
        if (t.stopIds && _.includes(t.stopIds, ad.stopId)) {
          this.activityDetailsMap[t.id] = ad;
        }
      })

    })
  }

  private _setIsRouteProcessRunning() {
    this.isRunning = this.route?.actionProcess?.running && (new Date().getTime() < this.route?.actionProcess?.expirationDate);
  }

  // drop(event: CdkDragDrop<string[]>) {
  //
  //   if (!event.isPointerOverContainer) {
  //     return false;
  //   }
  //
  //   // Add Job To Route
  //   if (event.item.data.jobType) {
  //     const jobId = _.get(event.item.data, 'id');
  //
  //     if (this.jobsMap[jobId].lockedRouteId) {
  //       return false;
  //     }
  //     const jobVehicleTypes = _.map(this.jobsMap[jobId].allowedVehicleReferences, 'type');
  //     if (this.isValidateRouteVehicles && !!this.route.resource?.vehicleClass &&
  //       jobVehicleTypes?.length && !jobVehicleTypes.includes(this.route.resource.vehicleClass)) {
  //
  //       this.confirmDialogService.confirm("Confirm",
  //         "Service vehicle types do not match route resource vehicle type. Are you sure you want to proceed?")
  //         .then(() => {
  //           if (this.selectedJobIds.length && _.includes(this.selectedJobIds, jobId)) {
  //             return this._dropJobs(this.selectedJobIds);
  //           } else {
  //             return this._dropJob(event);
  //           }
  //         })
  //         .catch(() => {
  //           return false;
  //         });
  //
  //     } else if (this.selectedJobIds.length && _.includes(this.selectedJobIds, jobId)) {
  //       return this._dropJobs(this.selectedJobIds);
  //     } else {
  //       return this._dropJob(event);
  //     }
  //
  //   }
  //   // Add Activity To Route
  //   else {
  //
  //     const jobIds = event.item.data?.jobIds ? event.item.data.jobIds : [event.item.data.jobId];
  //     const fromRouteId = _.get(event.previousContainer, 'data[0].routeId')
  //     const toRouteId = this.route.id;
  //
  //     // this._activityDrop(jobIds, itemJobs, fromRouteId, toRouteId, event);
  //   }
  // }
  //
  // private _activityDrop(jobIds, itemJobs, fromRouteId, toRouteId, event) {
  //   if (this.isMultipleActivitiesDragged(jobIds)) {
  //     return this._dropJobs(this.selectedJobIds);
  //   }
  //
  //   const itemSkills = _.flatMap(itemJobs, (j) => {
  //     return j.skills || [];
  //   })
  //
  //   const currentRouteSkills = this.route.resource?.allocationSkills;
  //   if (currentRouteSkills && !!_.difference(itemSkills, currentRouteSkills).length) {
  //     this.planningAlertsService.noMatchingSkillsInfo();
  //     return false
  //   }
  //
  //   if (event.previousContainer === event.container) {
  //     moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
  //   } else {
  //     transferArrayItem(
  //       event.previousContainer.data,
  //       event.container.data,
  //       event.previousIndex,
  //       event.currentIndex
  //     );
  //   }
  //
  //   if ((event.previousContainer === event.container) && (event.currentIndex === event.previousIndex)) {
  //     return;
  //   }
  //
  //   const payload = {
  //     jobIds: event.item.data.jobIds || [event.item.data.jobId],
  //     fromRouteId: fromRouteId,
  //     toRouteId: toRouteId,
  //     fromOrderedIds: this._getStopsOrderIds(event.previousContainer.data),
  //     toOrderedIds: (fromRouteId !== toRouteId) ? this._getStopsOrderIds(event.container.data) : undefined
  //   }
  //   this.onMoveJobs.emit(payload);
  // }
  //
  // private _getActivitiesJobIds(activities) {
  //   return _.chain(activities)
  //     .map((a: any) => {
  //       return a.jobId || a.jobIds;
  //     })
  //     .flatten()
  //     .value()
  // }

  // private _canJobAddToRoute(job, route) {
  //
  //   // Already In Route
  //   if (_.includes(route.jobIds, job.id)) {
  //     this.planningAlertsService.alreadyInRouteInfo();
  //     return false;
  //   }
  //
  //   // Route Is Locked
  //   if (!!route.locked) {
  //     this.planningAlertsService.routeIsLocked();
  //     return false;
  //   }
  //
  //   // Route Is Optimizing
  //   if (!!route.actionProcess?.running) {
  //     this.planningAlertsService.routeIsLocked();
  //     return false;
  //   }
  //
  //   // Route Is Dispatched
  //   if (route.status === 'DISPATCHED' && !this.isAllowDraggingIntoDispatchedRoute) {
  //     this.planningAlertsService.routeIsDispatchedInfo();
  //     return false;
  //   }
  //
  //   // Skills Match
  //   const jobSkills = _.get(job, 'skills', (job.jobType === 'Operation' ? ['Merchandise'] : ['Delivery']))
  //   const resourceSkills = _.get(route, 'resource.allocationSkills', []);
  //   const hasMatchingSkills = !_.difference(jobSkills, resourceSkills).length;
  //
  //   if (!hasMatchingSkills) {
  //     this.planningAlertsService.noMatchingSkillsInfo();
  //     return false;
  //   }
  //
  //   return true;
  //
  //   // if (!_.includes(resourceSkills, leftoverSkill)) {
  //   //   const stopType = this.$filter('translate')('SKILLS.' + leftoverSkill);
  //   //   const routeType = this.$filter('translate')('SKILLS.' + resourceSkills[0]);
  //   //   this.planningAlertsService.stopTypeToRouteRejectionInfo(stopType, routeType);
  //   //   canAddBulk = false;
  //   //   return false;
  //   // }
  // }

  // private _dropJobs(jobIds) {
  //   const jobsToAdd = [];
  //
  //   jobIds.forEach((id) => {
  //     const job = this.jobs.find((j) => {
  //       return j.id === id;
  //     })
  //     if (!!job) {
  //       jobsToAdd.push(job);
  //     }
  //   })
  //
  //   let jobIdsToMove = [];
  //   let stopIds = [];
  //   jobsToAdd.forEach((j) => {
  //     const canAdd = this._canJobAddToRoute(j, this.route);
  //     if (!!canAdd) {
  //       jobIdsToMove.push(j.id);
  //       stopIds = stopIds.concat(_.map(_.get(j, 'stops') || [], 'id'));
  //     }
  //   })
  //
  //   if (!jobIdsToMove.length) {
  //     return false;
  //   }
  //
  //   const payload = {
  //     jobIds: jobIdsToMove,
  //     toRouteId: this.route.id,
  //     // fromOrderedIds: this._getStopsOrderIds(event.previousContainer.data),
  //     toOrderedIds: _.concat(this._getStopsOrderIds(this.route.activities), stopIds)
  //   }
  //   this.onMoveJobs.emit(payload);
  //   // this.onAddStopsToRoute.emit(payload);
  //   return false;
  // }
  //
  // private _dropJob(event: CdkDragDrop<string[]>) {
  //   // const canAdd = this._canJobAddToRoute(event.item.data, this.route);
  //   //
  //   // if (!canAdd) {
  //   //   return false;
  //   // }
  //   //
  //   // const jobStopIds = _.map(event.item.data.stops, 'id');
  //   // let routeStopActivities = _.filter(this.route.activities, (a) => {
  //   //   return _.isEqual(a.type, 'STOP') || _.isEqual(a.type, 'GROUP')
  //   // })
  //   // let routeStopIds = _.map(routeStopActivities, (s) => {
  //   //   return s.stopIds || s.stopId;
  //   // });
  //   //
  //   // routeStopIds.splice(event.currentIndex, 0, ...jobStopIds);
  //   // routeStopIds = _.flatten(routeStopIds);
  //   //
  //   // const payload = {
  //   //   routeId: this.route.id,
  //   //   jobIds: [event.item.data.id],
  //   //   order: routeStopIds
  //   // }
  //   // this.onAddStopsToRoute.emit(payload);
  //   //
  //   // return false;
  //
  //
  //   const jobId = _.get(event.item.data, 'id');
  //   const jobType = _.get(event.item.data, 'jobType');
  //   const fromRouteId = _.get(event.item.data, 'routeId')
  //
  //   const canAdd = this._canJobAddToRoute(event.item.data, this.route);
  //   if (!canAdd) {
  //     return false;
  //   }
  //
  //   const stopIds = _.map(_.get(event.item.data, 'stops') || [], 'id');
  //   const payload = {
  //     jobIds: [jobId],
  //     fromRouteId: fromRouteId,
  //     toRouteId: this.route.id,
  //     // fromOrderedIds: this._getStopsOrderIds(event.previousContainer.data),
  //     toOrderedIds: _.concat(this._getStopsOrderIds(this.route.activities), stopIds)
  //   }
  //   this.onAddStopsToRoute.emit(payload);
  //
  //   return false;
  // }


  private _getStopsOrderIds(activities) {
    return _.chain(activities)
      .filter((a: any) => {
        return _.isEqual(a.type, 'STOP') || _.isEqual(a.type, 'GROUP');
      })
      .map((filteredItem: any) => {
        return filteredItem.stopId || filteredItem.stopIds;
      })
      .flatten()
      .value()
  }


}
